<template>
  <section class="settings container">
    <h1 class="mb-1e is-size-3">Ustawienia</h1>

    <div v-if="toggleCleanSuccess" class="notification is-success is-light mt-3">
      <button class="delete" @click="toggleCleanSuccess = false"></button>
      <strong>Dane zostały wyczyszczone.</strong>
    </div>

    <div v-if="toggleSuccess" class="notification is-success is-light">
      <button class="delete" @click="toggleSuccess = false"></button>
      <strong>Dane zostały zapisane.</strong><br>
      Przejdź do <router-link to="/"><strong>Lista terenów</strong></router-link>,
      by zobaczyć wszystkie pobrane ({{ importedTerritoriesCount }}) tereny.
    </div>

    <h2 class="mb-1e is-size-4">Centrum terenu</h2>
    <div class="center">
      <label class="label">Podaj długość i szerokość geograficzną oraz zoom</label>
      <div class="field has-addons">
        <div class="control">
          <input type="number" class="input" v-model="map.center.lat" placeholder="Latitude">
        </div>
        <div class="control">
          <input type="number" class="input" v-model="map.center.lng" placeholder="Longitude">
        </div>
        <div class="control">
          <input type="number" class="input" v-model="map.zoom" placeholder="Zoom">
        </div>
      </div>
      <div class="field">
        <div class="control">
          <button type="button" class="button is-info" @click.prevent="saveMap">
            Zapisz
          </button>
        </div>
      </div>
    </div>

    <h2 class="mb-2 is-size-4">Przechowywanie danych</h2>
    <template v-if="listCount">
      <!-- eslint-disable max-len -->
      <p>Dane przechowywane są w pamięci przeglądarki. Nikt inny nie ma do nich dostępu.</p>
      <p class="mb-3">
        Aby nie utracić danych, zachęcamy do regularnego zapisywania terenów w postaci pliku zapisanego na dysku. Żeby to zrobić należy wybrać "Zapisz plik JSON".
      </p>
      <!-- eslint-enable -->

      <div class="control">
        <button
          type="button"
          class="button"
          @click.prevent="exportDataAsJson">
          Zapisz plik JSON
        </button>
      </div>
    </template>

    <!-- eslint-disable max-len -->
    <p class="mt-5 mb-3">Istnieje możliwość załadowania do aplikacji zachowanego tak pliku. W tym celu należy skorzystać z opcji "Wybierz plik", a następnie wybrać z dysku właściwy pliku i zaimportować.</p>
    <!-- eslint-enable -->

    <div class="file has-name is-boxed">
      <label class="file-label">
        <input class="file-input" type="file" @change="setImportFile">
        <span class="file-cta">
          <span class="file-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2023 Fonticons, Inc. --><path d="M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/></svg>
          </span>
          <span class="file-label mt-2">
            Wybierz plik
          </span>
        </span>
        <span class="file-name" v-if="importFileName">
         {{ importFileName }}
        </span>
      </label>
    </div>

    <div v-if="importFile" class="control mt-3">
      <button
        type="button"
        class="button is-info"
        @click="importDataAsFile"
        >
        Importuj dane
      </button>
    </div>

    <template v-if="listCount">
      <h2 class="mt-5 pt-5 mb-2 is-size-4">Usuń dane z pamięci przeglądarki</h2>
      <div class="control ml-auto">
        <button
          type="button"
          class="button is-danger"
          @click.prevent="remove">
          Wyczyść pamięć
        </button>
      </div>
    </template>

    <div v-if="listCount" class="mt-5 pt-5">
      <h2 class="mb-1 is-size-4">Rodzaje kart terenu</h2>
      <p class="help mb-3">Kolory będą wykorzystywane, żeby wyróżnić na mapie dany rodzaj terenu.</p>

      <div class="form-colors">
        <div
          class="field is-horizontal"
          v-for="(type, key, index) in localMapTypes"
          :key="`type-${key}`"
          >
          <div class="field-body">
            <div class="field">
              <p class="control">
                <input class="input" type="text" v-model="type.label">
              </p>
            </div>
            <div class="field is-flex-grow-0">
              <p class="control">
                <input class="input is-success" type="color" v-model="type.color">
              </p>
            </div>
            <button
              v-if="index === Object.keys(localMapTypes).length - 1"
              class="button"
              type="button"
              @click="addMapType">
              <span class="icon is-small">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/>
                </svg>
              </span>
            </button>
          </div>
        </div>

        <button
          type="button"
          class="button is-default"
          @click.prevent="saveMapTypes"
          >
          Zapisz
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import dayjs from 'dayjs';
import { mapActions, mapMutations, mapState } from 'vuex';
import { fetchData, saveData, removeData } from '@/api';
import {
  hasProp,
  uuid,
} from '@/utils';

export default {
  data: () => ({
    importFile: null,
    textData: '',
    toggleCleanSuccess: false,
    toggleSuccess: false,
    importedTerritoriesCount: '',
    localMapTypes: {},
    map: {
      center: {
        lat: '',
        lng: '',
      },
      zoom: '',
    },
  }),
  mounted() {
    if (this.settings && this.settings.map) {
      const { center, zoom } = this.settings.map;

      this.$set(this.map, 'center', center);
      this.$set(this.map, 'zoom', zoom);
    } else {
      this.$set(this, 'map', this.defaultMap);
    }

    this.localMapTypes = {
      ...this.localMapTypes,
      ...this.mapTypes,
    };
  },
  computed: {
    ...mapState([
      'mapTypes',
      'list',
      'settings',
      'defaultMapSettings',
    ]),
    listCount() {
      return Object.keys(this.list).length;
    },
    importFileName() {
      if (this.importFile) {
        return this.importFile.name;
      }

      return '';
    },
  },
  methods: {
    ...mapActions([
      'SET_MAP_COLORS',
    ]),
    ...mapMutations({
      initStore: 'INITIALISE_STORE',
      cleanStore: 'CLEAN_STORE',
      createItem: 'CREATE_ITEM',
      saveMapSettings: 'SAVE_MAP_SETTINGS',
    }),
    remove() {
      removeData();
      removeData(this.$lc.preferencesName);

      this.toggleCleanSuccess = true;
      this.toggleSuccess = false;

      this.cleanStore();

      // clear map
      this.$set(this, 'map', this.defaultMapSettings);
    },
    async downloadZip() {
      const { saveAs } = await import('file-saver');
      const { default: JSZip } = await import('jszip');

      const zip = new JSZip();
      const date = dayjs().format('YYYY-MM-DD-HH-mm-ss');
      const cleanName = `${date}-lista-terenow`;

      // creates file
      zip.file(`${cleanName}.json`, this.textData);

      // generates zip
      zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE',
        compressionOptions: {
          level: 9,
        },
      }).then((blob) => {
        saveAs(blob, `${cleanName}.zip`);
      }, err => console.error(err)); // eslint-disable-line
    },
    async exportDataAsJson() {
      const lc = fetchData();
      this.textData = JSON.stringify(lc, null, 2);

      await this.downloadZip();
    },
    setImportFile(e) {
      this.toggleSuccess = false;
      this.importedTerritoriesCount = '';

      this.importFile = e.target.files[0];  // eslint-disable-line
    },
    importDataAsFile() {
      const reader = new FileReader();
      const that = this;

      reader.onload = () => {
        const jsonData = JSON.parse(reader.result);
        const result = saveData(jsonData);

        if (result) {
          that.textData = '';
          that.initStore();

          this.importFile = null;
          this.toggleSuccess = true;
          this.importedTerritoriesCount = Object.keys(jsonData.tr).length;
          this.toggleCleanSuccess = false;

          this.$set(this, 'map', jsonData.settings.map);
        }
      };

      reader.readAsText(this.importFile);
    },
    saveMap() {
      this.saveMapSettings(this.map);
    },
    addMapType() {
      const uid = uuid();

      if (hasProp(this.localMapTypes, uid)) {
        this.addMapType();
      } else {
        this.$set(this.localMapTypes, uid, {
          label: '',
          color: '#000000',
        });
      }
    },
    saveMapTypes() {
      this.SET_MAP_COLORS(this.localMapTypes)
        .then((localMapTypes) => {
          this.$set(this, 'localMapTypes', localMapTypes);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  margin-bottom: 4rem;
}

.form-colors {
  width: 25rem;
  max-width: 100%;

  input[type="color"] {
    width: 4rem;
  }

  .button .icon.is-small {
    width: 1em;
    height: 1em;
  }
}
</style>
